import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.css']
})
export class ComingSoonComponent implements OnInit {

  constructor(private router:Router,private dialogRef: MatDialogRef<ComingSoonComponent>) { }

  ngOnInit() {
  }
close(){
  this.dialogRef.close();
  this.router.navigate(["/main/dashboards/dashboard3"])
}
}
